<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 10:50:06
 * @LastEditTime: 2019-08-22 11:11:19
 * @LastEditors: Please set LastEditors
 -->
<template>
  <el-container>
    <el-aside>
      <div class="logo" :class="{ 'logo--collapse': isCollapse }">
        <img :src="logos.img_url"  alt>
        {{logos.vendorname}}
      </div>
      <!--  -->
      <!-- <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        text-color="#fff"
        active-text-color="#fff"
        :unique-opened="true"
        :default-openeds="activeArray"
        :collapse="isCollapse"
      >
        <el-menu-item index="/survey" @click='link("/survey")'>
          <i class="el-icon-menu"></i>
          <span slot="title">概况</span>
        </el-menu-item>
        <el-submenu v-for="(items,index) in menu" :index='items.path'  :key="index">
          <template slot="title">
            <i :class="items.class"  style="font-weight: 400;color: #fff"></i>
            <span style="margin-left: 10px">1{{items.name}}</span>
          </template>
          <el-menu-item-group v-for="(item,itemIndex) in items.children" :key="itemIndex">
            <el-menu-item  :index="item.path"  @click='link(item.path)'>
              2{{item.name}}
               <el-menu-item :index="i.path" v-for="(i,iIndex) in item.chldren" :key="iIndex" @click='link(i.path)'>
                 {{i.name}}
                </el-menu-item>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu> -->
      <!-- 111111 -->
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        text-color="#fff"
        active-text-color="#fff"
        :unique-opened="true"
        :default-openeds="activeArray"
        :collapse="isCollapse">
    <!-- 一级菜单 -->
        <template v-for="item in menu">
          <el-submenu v-if="item.children && item.children.length" :index="item.path" :key="item.path">
            <template slot="title"><i :class="item.class"></i><span>{{item.name}}</span></template>
            <!-- 二级菜单 -->
            <template v-for="itemChild in item.children">
              <el-submenu v-if="itemChild.children && itemChild.children.length" :index="itemChild.path" :key="itemChild.path" @click='link(itemChild.path)'>
                  <template slot="title" >
                      <i :class="itemChild.class"></i><span>{{itemChild.name}}</span>
                  </template>
                  <!-- 三级菜单 -->
                  <el-menu-item v-for="itemChild_Child in itemChild.children" :index="itemChild_Child.path" :key="itemChild_Child.path" @click='link(itemChild_Child.path)'>
                      <span slot="title">{{itemChild_Child.name}}</span>
                  </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="itemChild.path" :key="itemChild.path" @click='link(itemChild.path)'><span slot="title">{{itemChild.name}}</span></el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else :index="item.path" :key="item.path" @click='link(item.path)' ><i :class="item.class"></i><span slot="title">{{item.name}}</span></el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="clearfix">
        <div class="left fl">
          <i class="el-icon-s-fold" v-if="!isCollapse" @click="isCollapse=!isCollapse"></i>
          <i class="el-icon-s-unfold" v-if="isCollapse" @click="isCollapse=!isCollapse"></i>
          <i class="el-icon-refresh" @click="refresh"></i>
        </div>
        <div class="right fr">
          <router-link tag='span' to='message'>
              <el-badge :is-dot='has_msg' class="item">
            <i class="el-icon-bell"></i>
          </el-badge>
          </router-link>
          <div class="messageProup" v-if='has_msg'>
              您有新消息,请查收
              <i class="el-icon-close" @click='has_msg=!has_msg'></i>
          </div>
          <i class="el-icon-delete" @click="delCashe"></i>
          <i class="el-icon-rank" @click="fullPage"></i>
          <el-dropdown>
            <span class="el-dropdown-link">
              {{name}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>基本资料</el-dropdown-item>
              <el-dropdown-item>修改密码</el-dropdown-item>
              <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <i class="el-icon-more" @click="is_open=!is_open"></i>
        </div>
      </el-header>
      <el-main>
        <router-view :key="activeDate"></router-view>
      </el-main>
    </el-container>
    <div class="poup" v-if="is_open" @click="is_open=!is_open">
      <div class="main">
        <div class="copyHead">版权信息</div>
        <div class="copy">© 2010-2018 {{logos.companyname}}</div>
      </div>
    </div>
  </el-container>
</template>
<script>
export default {
  name: "root",
  data() {
    return {
      isCollapse: false,
      navselected: "survey",
      activeArray: [],
      is_open: false,
      has_msg:false,
      activeDate: "", // 时间戳 用于刷新
      name:'',
      logos:{},
      menu: [
        // {
        //   name: "客户管理",
        //   path: "customer",
        //   class: "el-icon-s-custom",
        //   children: [
        //     {
        //       name: "下级经销商管理",
        //       path: "/next_leve"
        //     },
        //     {
        //       name: "门店管理",
        //       path: "/storeManage"
        //     },
        //     {
        //       name: "导购管理",
        //       path: "/",
        //       children:[
        //         {
        //           name: "导购管理",
        //           path: "/guideManage",
        //         },
        //         {
        //           name: "添加导购",
        //           path: "/addGuide",
        //         },
        //         {
        //           name: "审核",
        //           path: "/examine"
        //         },
        //       ]
              
        //     },
            
        //   ]
        // },
        // {
        //   name: "二维码营销",
        //   path: "scanMarket",
        //   class: "el-icon-camera-solid",
        //   children: [
        //     {
        //       name: "概况",
        //       path: "/scanSurvey"
        //     },
        //     {
        //       name: "扫码管理模板",
        //       path: "/scanManageTemplate",
        //       children:[
        //         {
        //           name: "扫码管理模板",
        //           path: "/scanManageTemplate",
        //         },
        //         {
        //           name: "创建扫码模板",
        //           path: "/setScanTemplate",
        //         },
        //       ]
        //     },
        //     {
        //       name: "创建活动第一步",
        //       path: "/setActivityOne",
        //       children:[
        //         {
        //           name: "创建活动第一步",
        //           path: "/setActivityOne",
        //         },
        //         {
        //           name: "创建活动第二步",
        //           path: "/setActivityTwo",
        //         },
        //       ]
        //     },
        //     {
        //       name: "活动管理",
        //       path: "/activityManage",
        //     },
        //     {
        //       name: "扫码明细",
        //       path: "/scanInfo",
        //     },
        //     {
        //       name: "领奖记录",
        //       path: "/scanRecord",
        //     },
        //     {
        //       name: "数据统计",
        //       path: "/dataStatistics",
        //     },
        //   ]
        // },
        // {
        //   name: "财务管理",
        //   path: "finance",
        //   class: "el-icon-coin",
        //   children: [
        //     {
        //       name: "营销经费管理",
        //       path: "/marketFunds",
        //       children: []
        //     },
        //   ]
        // },
        // {
        //   name: "货品管理",
        //   path: "goods",
        //   class: "el-icon-box",
        //   children: [
        //     {
        //       name: "入库管理",
        //       path: "/instockManage",
        //       children: []
        //     },
        //     {
        //       name: "发货管理",
        //       path: "/deliverManage",
        //       children: []
        //     },
        //     {
        //       name: "退货管理",
        //       path: "/refundManage",
        //       children: []
        //     },
        //     {
        //       name: "调拨单管理",
        //       path: "/requisitionManage",
        //       children: []
        //     },
        //     {
        //       name: "零售管理",
        //       path: "/retailManage",
        //       children: []
        //     },

        //     {
        //       name: "追踪查询",
        //       path: "/traceManage",
        //       children: []
        //     }
        //   ]
        // },
        // {
        //   name: "订单管理",
        //   path: "order",
        //   class: "el-icon-document-copy",
        //   children: [
        //     {
        //       name: "商品上下架管理",
        //       path: "/goodsOnput",
        //       children: []
        //     },
        //     {
        //       name: "我的订单",
        //       path: "/myorder",
        //       children: []
        //     },

        //     {
        //       name: "下级经销商订单",
        //       path: "/next_order",
        //       children: []
        //     },

        //     {
        //       name: "门店订单",
        //       path: "/store_order",
        //       children: []
        //     },
        //     {
        //       name: "我的返利",
        //       path: "/rebate",
        //       children: []
        //     }
        //   ]
        // },
        // {
        //   name: "信息管理",
        //   path: "info",
        //   class: "el-icon-folder-opened",
        //   children: [
        //     {
        //       name: "文件库",
        //       path: "/library"
        //     },
        //     {
        //       name: "公告列表",
        //       path: "/announcement"
        //     }
        //   ]
        // },
        // {
        //   name: "统计报表",
        //   path: "statistics",
        //   class:'el-icon-document-remove',
        //   children: [
        //     {
        //       path: "/inventoryStatistics",
        //       name: "库存统计"
        //     },
        //     {
        //       path: "/turnover",
        //       name: "产品周转率统计"
        //     },
        //     {
        //       name: "门店订货排行",
        //       path: "/orderRaking"
        //     }
        //     // ,
        //     // {
        //     //   name: "生意情况一览表",
        //     //   path: "/business"
        //     // }
        //     // ,
        //     // {
        //     //   name: "盘点统计",
        //     //   path: "/inventory"
        //     // }
        //   ]
        // },
        // {
        //   name: "系统管理",
        //   path: "system",
        //   class: "el-icon-setting",
        //   children: [
        //     {
        //       name: "员工管理",
        //       path: "/staffManagement",
        //       children: []
        //     },
        //     {
        //       name: "操作日志",
        //       path: "/log",
        //       children: []
        //     }
        //   ]
        // }
      ]
    };
  },
  watch: {
    $route(to, from) {
      this.navselected = to.path;
      this.activeArray[0] = to.path;
    }
  },
  created(){
  this.init();
  this.getOem()
  },
  mounted() {
  
  },
  methods: {
       getOem(){
          // 获取OEM品牌商图片
          this.$get("logistics_1", "/vendor/logo", {
            customer_id:sessionStorage.getItem('customer_id'),
            lan:'zh-CN'
          })
            .then(res => {
                this.logos=res.data
            })
            .catch(error => {
            // console.log(error);
            });

    },
    init() {
      this.$get('login','/profile').then(res=>{
          this.name=res.data.dealer_name
          this.mobile=res.data.mobile
          sessionStorage.setItem('mobile',this.mobile)
          this.getmenu()
        })
      this.activeArray[0] = this.$route.path;
      this.navselected = this.$route.path;
      this.$get('logistics','/inmails.status').then(res=>{
          if(res.data.count>0){
            this.has_msg=true
          }
      })
    },
    getmenu(){
      this.$post('logistics_2','publics/Dealerpc.Dealerpc/getMainMenu',{
        customer_id:sessionStorage.getItem('customer_id'),
        mobile:sessionStorage.getItem('mobile')
      }).then(res=>{
        this.menu=res.menu
      })
    },
    link(path){
      this.$router.push({path:path})
    },
       //退出
    logout(){
       localStorage.clear()
          console.log(sessionStorage.getItem('customer_id'))
          this.$router.push({
            name:'login',
            query:{
              customer_id:sessionStorage.getItem('customer_id')
            }
          })
      //      this.$get("dealer_pc", "admin/login/logout",{
      //   customer_id:sessionStorage.getItem('customer_id'),
      // }).then(res => {
      // }).catch(error=>{
      // });
    },
    refresh() {
      this.activeDate = new Date().getTime();
      this.$message({
        type: "success",
        message: "刷新成功!"
      });
    },
    delCashe() {
      this.$confirm("此操作将清除缓存, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // sessionStorage.clear();
          // localStorage.clear();
          window.location.reload()
          this.refresh();
          this.$message({
            type: "success",
            message: "清除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消清除"
          });
        });
    },
    open(value){
      console.log(value)
    },
    // 全屏
    fullPage() {
      let element = document.body;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    }
  }
};
</script>



<style lang="scss" scoped>
.el-container {
  height: 100%;
  width: 100%;
}
.el-header,
.el-footer {
  background-color: rgb(58, 61, 71);
  color: #333;
  text-align: center;
  position: relative;
  max-height: 56px;
}
.el-menu-vertical-demo:not(.el-menu--collapse, .logo--collapse) {
  width: 300px;
}

.el-aside {
  background-color: rgb(32, 34, 41);
  color: #333;
  text-align: center;
  position: relative;
  top: 0;
  bottom: 0;
  text-align: left;
  width: auto !important;
  .el-menu {
    border-right: none;
  }
  li {
    background-color: rgb(32, 34, 41);
  }

  div {
    background-color: transparent;
  }
  .logo {
    max-width: 300px;
    padding: 15px 0;
    // text-align: center;
    transition: max-width 0.5s;
    color: #fff;
    font-weight: 600;
    vertical-align: middle;
    display: flex;
    align-items: center;

    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
    img {
      //  position: absolute;
      //  left: 50%;
      //  transform: translateX(-50%);
      margin-left: 25px;
      width: 20%;
      height: auto !important;
      margin-right: 15px;

    }
  }
  .logo--collapse {
    max-width: 0;
    max-height: 0;
    padding: 0;
  }
}

.el-main {
  background-color: #e9eef3;
  color: #333;

  position: relative;
}

body > .el-container {
  margin-bottom: 40px;
}
.el-menu-item,
.el-submenu__title,
.el-submenu,
.el-submenu__title {
  background-color: rgb(32, 34, 41) !important;
}
.el-submenu .is-active,
.el-menu-item.is-active {
  background-color: rgb(0, 150, 136) !important;
  color: #fff !important;
}
.el-input--suffix {
  width: 50px;
}
header {
  .left {
    float: left;
  }
  .right {
    float: right;
    > i:last-child {
      transform: rotate(90deg);
    }
  }
  > div {
    line-height: 60px;
    font-size: 25px;
    i {
      color: #fff;
      margin-right: 20px;
    }
  }
}
.poup {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  z-index: 999999999999;
  top: 0;
  right: 0;
  .main {
    background-color: #fff;
    width: 300px;
    height: 100%;
    position: absolute;
    right: 0;
    animation: transIn 0.3s linear;
    padding: 0 10px;
    font-size: 15px;
    color: #333;
    .copyHead {
      padding: 20px 0;
      border-bottom: 1px solid #eee;
    }
    .copy {
      padding-top: 20px;
    }
  }
}
@keyframes transIn {
  0% {
    transform: translateX(100%);
  }

  50% {
    transform: translateX(50%);
  }
  100% {
    transform: translateX(0);
  }
}
.el-dropdown {
}
.el-dropdown-link {
  position: relative;
  top: -5px;
  cursor: pointer;
  line-height: 10px;
  color: #fff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.messageProup{
  position: fixed;
  z-index: 999999999;
  right: 300px;
  top: 40px;
  color: #f04635;
  background-color: #fff;
  // border-radius: 25px;
  height: 25px;
  line-height: 25px;
  padding: 5px 25px;
  font-size: 14px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.5);
  border-radius: 8px;
  i{
    color: #000;
    position: absolute;
    right: -15px;
    top: 0px;
  }

}
  /deep/.el-badge__content.is-fixed.is-dot{
    right:20px;
    top:8px;
  } 
</style>
